export const CustomReportStepKeys = {
    Component: 'Component',
    Form: 'Form',
}

export const ReorderType = {
    Section: 1,
    Question: 2,
}

export const CustomReportSteps = [
    {
        key: 'Component',
        title: 'Component',
        description: 'Choose your Component options',
        active: true,
    },
    {
        key: 'Form',
        title: 'Components form',
        description: 'Enter form information',
    },
]

export const ReportMenus = {
    AboutUs: 'about-us',
    Header: 'header',
    Footer: 'footer',
    LimitationAndPrecaution: 'limitation-precaution',
    DataAndInformationDisclaimer: 'data-information-disclaimer',
    LegalDisclaimer: 'legal-disclaimer',
}

export const ReportControlType = {
    TextArea: '8',
    Upload: '10',
}

export const PdfImageCompressionTabId = 'pdf-image-compression'

export const formatSubsectionName = SubsectionName => {
    if (!SubsectionName) return SubsectionName
    return SubsectionName
        .replace(/[:]/g, '')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
}
